import React from 'react';
import styled from 'styled-components';
import { FiSearch, FiX } from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 10px 40px 10px 40px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
  background: white;

  &:focus {
    outline: none;
    border-color: #5efba9;
    box-shadow: 0 0 0 3px rgba(94, 251, 169, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

const ClearButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background: #f3f4f6;
    color: #6b7280;
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }
`;

/**
 * SearchBar Component
 * 
 * A reusable search input for filtering products
 * 
 * @param {Object} props
 * @param {string} props.value - Current search value
 * @param {Function} props.onChange - Callback when search value changes
 * @param {string} props.placeholder - Optional custom placeholder
 */
function SearchBar({ value, onChange, placeholder }) {
  const { isArabic } = useLanguage();

  const defaultPlaceholder = isArabic 
    ? 'ابحث عن المنتجات...' 
    : 'Search products...';

  const handleClear = () => {
    onChange('');
  };

  return (
    <SearchContainer>
      <SearchIcon>
        <FiSearch size={18} />
      </SearchIcon>
      <SearchInput
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || defaultPlaceholder}
      />
      {value && (
        <ClearButton onClick={handleClear} aria-label="Clear search">
          <FiX size={18} />
        </ClearButton>
      )}
    </SearchContainer>
  );
}

export default SearchBar;

